import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LoginComponent } from '../pages/authentication/login/login.component';
import { LogoutComponent } from '../pages/authentication/logout/logout.component';
import { RegisterComponent } from '../pages/authentication/register/register.component';

import { Authentication } from '../services/authentication.service';
import { HomeComponent } from '../pages/home/home.component';
import { DashboardComponent } from '../pages/dashboard/dashboard.component';

import { AccountVerifiedComponent } from '../pages/static/account-verified/account-verified.component';
import { StandardDiscountsComponent } from '../pages/administration/maintenance/standard-discount/standard-discount.component';

import { NotFoundComponent } from '../pages/static/not-found/not-found.component';
import { AccessDeniedComponent } from '../pages/static/access-denied/access-denied.component';
import { ProductImageComponent } from '../pages/administration/maintenance/product-image/product-image.component';
import { ProfileComponent } from '../pages/authentication/profile/profile.component';
import { UsersComponent } from '../pages/administration/users/users.component';
import { ForgotPasswordComponent } from '../pages/authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../pages/authentication/reset-password/reset-password.component';
import { OrderFormComponent } from '../pages/agents/orders/order-form/order-form.component';
import { PaymentFormComponent } from '../pages/agents/orders/payment-form/payment-form.component';
import { OrdersComponent } from '../pages/agents/orders/orders.component';
import { OrderDetailsComponent } from '../pages/agents/orders/order-details/order-details.component';
import { ConfigurationComponent } from '../pages/administration/configuration/configuration.component';
import { ActivationListComponent } from '../pages/agents/cards/activation/activation-list.component';
import { PaymentsComponent } from '../pages/agents/payments/payments.component';
import { CardsComponent } from '../pages/agents/cards/cards.component';
import { CommissionsComponent } from '../pages/agents/commissions/commissions.component';
import { BankTransactionsComponent } from '../pages/administration/bank-transactions/bank-transactions.component';
import { BankTransactionComponent } from '../pages/administration/bank-transactions/bank-transaction/bank-transaction.component';
import { DiscountsComponent } from '../pages/agents/discounts/discounts.component';
import { OverPaymentComponent } from '../pages/agents/orders/over-payment/over-payment.component';
import { TermsAndConditionsComponent } from '../pages/administration/terms-and-conditions/terms-and-conditions.component';
import { CommissionUploadsComponent } from '../pages/administration/commission-uploads/commission-uploads.component';
import { CommissionUploadComponent } from '../pages/administration/commission-uploads/commission-upload/commission-upload.component';
import { DiscountRatesComponent } from '../pages/administration/maintenance/discount/discount-rates.component';
import { Administrators } from '../services/authentication/administrators.service';
import { Partners } from '../services/authentication/partners.service';
import { PaymentFirst } from '../services/authentication/payment-first.service';
import { DiscountRequestsComponent } from '../pages/administration/maintenance/discount-requests/discount-requests.component';
import { AlreadyVerifiedComponent } from '../pages/static/already-verified/already-verified.component';
import { OtherOrdersComponent } from '../pages/administration/other-orders/other-orders.component';
import { OtherOrderDetailsComponent } from '../pages/administration/other-orders/other-order-details/other-order-details.component';
import { PaymentListComponent } from '../pages/administration/payment-list/payment-list.component';
import { VolumeDiscountsComponent } from '../pages/administration/maintenance/volume-discounts/volume-discounts.component';
import { VolumeDiscountRatesComponent } from '../pages/administration/maintenance/volume-discount-rates/volume-discount-rates.component';
import { VolumeDiscountRateRequestsComponent } from '../pages/administration/maintenance/volume-discount-rate-requests/volume-discount-rate-requests.component';
import { AuditTrailsComponent } from '../pages/administration/audit-trails/audit-trails.component';
import { CronjobsComponent } from '../pages/administration/cronjobs/cronjobs.component';
import { DiscountLimitsComponent } from '../pages/administration/discount-limits/discount-limits.component';
import { FaqComponent } from '@app/pages/faq/faq.component';

import { ProductsComponent } from '../pages/administration/products/products.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: '', component: HomeComponent },
      // { path: '', redirectTo: 'starter', pathMatch: 'full' },
      { path: 'login', component: LoginComponent/*, canActivate: [LoginRedirect]*/ },
      { path: 'forgot-password', component: ForgotPasswordComponent/*, canActivate: [LoginRedirect]*/ },
      { path: 'reset-password', component: ResetPasswordComponent/*, canActivate: [LoginRedirect]*/ },
      { path: 'logout', component: LogoutComponent, canActivate: [Authentication] },
      { path: 'register', component: RegisterComponent/*, canActivate: [LoginRedirect] */},
      { path: 'profile', component: ProfileComponent, canActivate: [Authentication] },

      { path: 'dashboard', component: DashboardComponent, canActivate: [Authentication] },

      // { path: ':username', component: ProfileComponent /*, canActivate: [Authentication] */ },
      // { path: ':username/:repo', component: RepositoryComponent /*, canActivate: [Authentication] */ },


      // { path: '', redirectTo: 'login', pathMatch: 'full' },


      { path: 'online-store', component: OtherOrdersComponent, canActivate: [Authentication, Administrators] },
      { path: 'online-store/:id/details', component: OtherOrderDetailsComponent, canActivate: [Authentication, Administrators] },

      { path: 'orders', component: OrdersComponent, canActivate: [Authentication] },
      { path: 'orders/form', component: OrderFormComponent, canActivate: [Authentication, Partners, PaymentFirst] },
      { path: 'orders/payment', component: PaymentFormComponent, canActivate: [Authentication, Partners] },
      { path: 'orders/:id/edit', component: OrderFormComponent, canActivate: [Authentication, Partners, PaymentFirst] },
      { path: 'orders/:id/payment', component: PaymentFormComponent, canActivate: [Authentication, Partners] },
      { path: 'orders/:id/details', component: OrderDetailsComponent, canActivate: [Authentication] },

      { path: 'orders/over-payment', component: OverPaymentComponent, canActivate: [Authentication, Administrators] },

      { path: 'payments', component: PaymentsComponent, canActivate: [Authentication] },
      { path: 'admin/payments', component: PaymentListComponent, canActivate: [Authentication, Administrators] },

      { path: 'commissions', component: CommissionsComponent, canActivate: [Authentication] },
      { path: 'discounts', component: DiscountsComponent, canActivate: [Authentication] },

      { path: 'cards', component: CardsComponent, canActivate: [Authentication] },

      { path: 'activations', component: ActivationListComponent, canActivate: [Authentication] },
      { path: 'admin/activations', component: ActivationListComponent, canActivate: [Authentication, Administrators] },

      { path: 'admin/discounts', component: DiscountRatesComponent, canActivate: [Authentication, Administrators] },
      { path: 'admin/discount-requests', component: DiscountRequestsComponent, canActivate: [Authentication, Administrators] },
      { path: 'admin/standard-discounts', component: StandardDiscountsComponent, canActivate: [Authentication, Administrators] },
      { path: 'admin/volume-discounts', component: VolumeDiscountsComponent, canActivate: [Authentication, Administrators] },
      { path: 'admin/volume-discount-rates', component: VolumeDiscountRatesComponent, canActivate: [Authentication, Administrators] },
      { path: 'admin/volume-discount-rate-requests', component: VolumeDiscountRateRequestsComponent, canActivate: [Authentication, Administrators] },

      { path: 'admin/product-images', component: ProductImageComponent, canActivate: [Authentication, Administrators] },
      { path: 'admin/products', component: ProductsComponent, canActivate: [Authentication, Administrators] },

      { path: 'bank-transactions', component: BankTransactionsComponent, canActivate: [Authentication, Administrators] },
      { path: 'bank-transactions/:id', component: BankTransactionComponent, canActivate: [Authentication, Administrators] },

      { path: 'commission-uploads', component: CommissionUploadsComponent, canActivate: [Authentication, Administrators] },
      { path: 'commission-uploads/:id', component: CommissionUploadComponent, canActivate: [Authentication, Administrators] },

      { path: 'configuration', component: ConfigurationComponent, canActivate: [Authentication, Administrators] },
      { path: 'cronjobs', component: CronjobsComponent, canActivate: [Authentication, Administrators] },
      { path: 'discount-limits', component: DiscountLimitsComponent, canActivate: [Authentication, Administrators] },
      { path: 'terms-and-conditions', component: TermsAndConditionsComponent, canActivate: [Authentication, Administrators] },

      { path: 'users', component: UsersComponent, canActivate: [Authentication, Administrators] },

      { path: 'audit-trails', component: AuditTrailsComponent, canActivate: [Authentication, Administrators] },

      { path: 'verified', component: AccountVerifiedComponent },
      { path: 'already-verified', component: AlreadyVerifiedComponent },

      { path: 'faq', component: FaqComponent },
      { path: '404', component: NotFoundComponent },
      { path: '401', component: AccessDeniedComponent },

      { path: '**', redirectTo: '/404' }
    ])
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
